var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphosColored = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 395,
    viewBox: "0 0 251 395",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "group-64-a",
    width: "124.9%",
    height: "115.1%",
    x: "-12.4%",
    y: "-7.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.309725996 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#group-64-a)",
    transform: "translate(7 15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M166.193898,264.911548 L168.250066,251.783511 L190.861247,193.21567 L196,171 L38,171 L43.1404195,193.21567 L65.7516004,251.783511 L67.8061019,264.911548 L72.9448552,299.245154 L83.7372367,334.082992 L80.652985,362.861862 L63.6954325,367.910729 C58.0418042,375.989899 66.778018,377 66.778018,377 L90.9321578,372.961234 L89.3891988,362.861862 L95.2994316,341.152061 L89.3891988,334.587224 L99.3501155,304.803165 L109.194394,293.367906 C109.194394,292.467492 109.944212,291.73079 110.860656,291.73079 L122.317876,291.73079 C123.234321,291.73079 123.984139,292.467492 123.984139,293.367906 L133.123588,304.803165 L143.084505,334.587224 L137.174272,341.152061 L143.084505,362.861862 L143.314449,362.861862 L141.77149,372.961234 L165.92563,377 C165.92563,377 174.660177,375.989899 169.008215,367.910729 L152.048997,362.861862 L151.820719,362.861862 L148.736467,334.082992 L159.528848,299.245154 L166.193898,264.911548 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M166.193898,264.911548 L168.250066,251.783511 L190.861247,193.21567 L196,171 L38,171 L43.1404195,193.21567 L65.7516004,251.783511 L67.8061019,264.911548 L72.9448552,299.245154 L83.7372367,334.082992 L80.652985,362.861862 L63.6954325,367.910729 C58.0418042,375.989899 66.778018,377 66.778018,377 L90.9321578,372.961234 L89.3891988,362.861862 L95.2994316,341.152061 L89.3891988,334.587224 L99.3501155,304.803165 L109.194394,293.367906 C109.194394,292.467492 109.944212,291.73079 110.860656,291.73079 L122.317876,291.73079 C123.234321,291.73079 123.984139,292.467492 123.984139,293.367906 L133.123588,304.803165 L143.084505,334.587224 L137.174272,341.152061 L143.084505,362.861862 L143.314449,362.861862 L141.77149,372.961234 L165.92563,377 C165.92563,377 174.660177,375.989899 169.008215,367.910729 L152.048997,362.861862 L151.820719,362.861862 L148.736467,334.082992 L159.528848,299.245154 L166.193898,264.911548 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF2729",
    d: "M143,230 L118,174"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "195.51 145 185.185 145 114.396 167.108 48.815 145 38.49 145 38 171.749 43.136 193.956 65.737 252.5 116.062 284 168.265 252.5 190.864 193.956 196 171.749"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "195.51 145 185.185 145 114.396 167.108 48.815 145 38.49 145 38 171.749 43.136 193.956 65.737 252.5 116.062 284 168.265 252.5 190.864 193.956 196 171.749"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M67,90.5 C67,107.34555 60.283783,121 51.9991586,121 C43.7145341,121 37,107.34555 37,90.5 C37,73.6544496 43.7145341,60 51.9991586,60 C60.283783,60 67,73.6544496 67,90.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M67,90.5 C67,107.34555 60.283783,121 51.9991586,121 C43.7145341,121 37,107.34555 37,90.5 C37,73.6544496 43.7145341,60 51.9991586,60 C60.283783,60 67,73.6544496 67,90.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M196,90.5 C196,107.34555 189.283783,121 180.999159,121 C172.714534,121 166,107.34555 166,90.5 C166,73.6544496 172.714534,60 180.999159,60 C189.283783,60 196,73.6544496 196,90.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M196,90.5 C196,107.34555 189.283783,121 180.999159,121 C172.714534,121 166,107.34555 166,90.5 C166,73.6544496 172.714534,60 180.999159,60 C189.283783,60 196,73.6544496 196,90.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141415",
    d: "M188.093345,86.7734363 C175.284052,138.094569 166.748387,194.473488 116.686835,194.99756 C74.0499053,195.442527 58.8264514,134.935306 45.2803262,86.7734363 C32.2988298,40.623805 77.2489169,0 116.686835,0 C156.123098,0 199.700525,40.2628876 188.093345,86.7734363"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M188.093345,86.7734363 C175.284052,138.094569 166.748387,194.473488 116.686835,194.99756 C74.0499053,195.442527 58.8264514,134.935306 45.2803262,86.7734363 C32.2988298,40.623805 77.2489169,0 116.686835,0 C156.123098,0 199.700525,40.2628876 188.093345,86.7734363 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D33",
    d: "M171.547325,104.418861 C161.788216,145.475037 155.284942,190.578103 117.142262,190.998048 C84.6578165,191.354017 73.0591087,142.948805 62.7371996,104.418861 C52.8470499,67.4997984 87.095494,35 117.142262,35 C147.189031,35 180.390836,67.2110863 171.547325,104.418861"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C556C",
    d: "M71.8887821,42 C83.4452023,30.5079351 98.9463065,23.4681049 115.999174,23.4681049 C133.053693,23.4681049 148.554798,30.5079351 160.111218,42 L171,42 C159.585701,19.7928031 139.226041,5 115.999174,5 C92.7739585,5 72.4142992,19.7928031 61,42 L71.8887821,42 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "201.137 207.815 195 237 207.025 237 218 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "201.137 207.815 195 237 207.025 237 218 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "29.863 207.815 36 237 23.975 237 13 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "29.863 207.815 36 237 23.975 237 13 202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M42.8819133,245.896734 C46.7255123,253.487847 45.193108,261.702521 39.4595996,264.245457 C33.7260913,266.788394 25.9616857,262.695193 22.1180867,255.102509 C18.2744877,247.511396 19.806892,239.296722 25.5404004,236.753786 C31.2739087,234.21242 39.0383143,238.305621 42.8819133,245.896734"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M42.8819133,245.896734 C46.7255123,253.487847 45.193108,261.702521 39.4595996,264.245457 C33.7260913,266.788394 25.9616857,262.695193 22.1180867,255.102509 C18.2744877,247.511396 19.806892,239.296722 25.5404004,236.753786 C31.2739087,234.21242 39.0383143,238.305621 42.8819133,245.896734 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212125",
    d: "M187.118087,245.896734 C183.274488,253.487847 184.806892,261.702521 190.5404,264.245457 C196.273909,266.788394 204.038314,262.695193 207.881913,255.102509 C211.725512,247.511396 210.193108,239.296722 204.4596,236.753786 C198.726091,234.21242 190.961686,238.305621 187.118087,245.896734"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M187.118087,245.896734 C183.274488,253.487847 184.806892,261.702521 190.5404,264.245457 C196.273909,266.788394 204.038314,262.695193 207.881913,255.102509 C211.725512,247.511396 210.193108,239.296722 204.4596,236.753786 C198.726091,234.21242 190.961686,238.305621 187.118087,245.896734 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "185 142.551 195.806 135.353 222.599 119 222.599 175.809 233 196.674 190.147 212 185 206.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "185 142.551 195.806 135.353 222.599 119 222.599 175.809 233 196.674 190.147 212 185 206.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "48 142.551 37.194 135.353 10.401 119 10.401 175.809 0 196.674 42.853 212 48 206.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "48 142.551 37.194 135.353 10.401 119 10.401 175.809 0 196.674 42.853 212 48 206.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "76.89 318 73 331.793 79.143 341.92 93.685 347 96 340.586 93.227 322.111"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "76.89 318 73 331.793 79.143 341.92 93.685 347 96 340.586 93.227 322.111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#212125",
    points: "154.11 318 158 331.793 151.857 341.92 137.315 347 135 340.586 137.773 322.111"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0292CA",
    strokeWidth: 2,
    points: "154.11 318 158 331.793 151.857 341.92 137.315 347 135 340.586 137.773 322.111"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0292CA",
    strokeWidth: 2,
    d: "M43 62L60.6873463 84.8045536C60.6873463 84.8045536 87.9662971 66.4848288 94.5332997 78.702984 94.5332997 78.702984 108.120995 115.032099 87.8989011 175M190 62L172.312654 84.8045536C172.312654 84.8045536 145.033703 66.4848288 138.4667 78.702984 138.4667 78.702984 124.879005 115.032099 145.101099 175"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphosColored, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos-colored.3004cec0.svg";
export { ForwardRef as ReactComponent };